import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import AddActionButton from "../common/AddActionButton";
import Modal from "../../../shared/ui/Modal";
import CustomForm from "../../../shared/components/form/CustomForm";
import {createTestTemplateConfig} from "../../../shared/components/form/TestTemplatesConfig";
import testTemplateActionCreators from "../../store/test-templates/action-creators";
import './TestTemplates.scss'
import {Alert} from "reactstrap";
import {withRouter} from "react-router-dom";

function mapStateToProps(state) {
  return {
    testTemplates: state.testTemplates.list,
    userContext: state.common.userContext
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTestTemplates() {
      return dispatch(testTemplateActionCreators.fetchTestTemplates());
    },
    createTestTemplates(form) {
      return dispatch(testTemplateActionCreators.createTestTemplates(form));
    },
    updateTestTemplate(form) {
      return dispatch(testTemplateActionCreators.updateTestTemplates(form));
    }
  };
}

class TestTemplates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isCreatingTestTemplate: false,
      isLoadingCreate: false
    }
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.props.fetchTestTemplates()
      .then(() => {
        this.setState({
          isLoading: false
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false
        });
      })
  }

  openCreateTestTemplate() {
    this.setState({
      isCreatingTestTemplate: true
    })
  }

  closeTestTemplate() {
    this.setState({
      isCreatingTestTemplate: false
    })
  }

  saveTestTemplate(form) {
    this.setState({
      isCreatingTestTemplate: true
    })
    this.props.createTestTemplates(form)
      .then(() => {
        this.closeTestTemplate()
        this.setState({
          isCreatingTestTemplate: false
        })
      })
      .catch(() => {
        this.setState({
          isCreatingTestTemplate: false
        })
      })
  }

  openTestTemplateDetails(tt) {
    this.props.history.push(`/test-templates/${tt.id}`);
  }

  openTestReports(testTemplate) {
    this.props.history.push(`/test-template-reports/${testTemplate.id}`);
  }

  archiveTestTemplate(testTemplate) {
    this.setState({
      isLoading: true
    });

    this.props.updateTestTemplate({
      ...testTemplate,
      status: 'archived'
    })
      .then(() => {
        this.setState({testTemplateForArchive: null})
      })
      .finally(() => {
      this.setState({
        isLoading: false
      });
    })
  }

  get filteredTestTemplates() {
    return this.props.testTemplates.filter(tt => tt.status !== 'archived')
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">Test templates</h4>
          {!this.props.userContext.hasScope(['fto']) &&
            <AddActionButton label={'test template'} onAdd={() => this.openCreateTestTemplate()}/>
          }
        </div>
        <div className="test-templates app-content">
          <div className="test-templates-card">
            {this.props.testTemplates.length ? (
              <table className="table table-stripped layout-auto">
                <thead>
                <tr>
                  <th>
                    <div className="header">
                      <span>Title </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Passing percentage </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Questions displayed </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Actions </span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                {this.filteredTestTemplates.map(tt => (
                  <tr key={tt.id}>
                    <td>{tt.title}</td>
                    <td>{tt.passing_score}</td>
                    <td>{tt.questions_displayed}</td>
                    <td>

                      <button className="button small secondary" onClick={() => this.openTestTemplateDetails(tt)}>
                        {!this.props.userContext.hasScope(['fto']) &&
                          <span>
                            <i className="fa fa-edit"/>
                            Edit
                          </span>
                        }

                        {this.props.userContext.hasScope(['fto']) &&
                          <span>
                            View Details
                          </span>
                        }
                      </button>

                      <button className="button small primary test-reports" onClick={() => this.openTestReports(tt)}>
                        Test Reports
                      </button>

                      <button className="button small delete test-reports" onClick={() => this.setState({testTemplateForArchive: tt})}>
                        Archive
                      </button>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            ) : (
              <Alert color="primary">No test templates created</Alert>
            )}
          </div>
        </div>

        <Modal
          title="Create test template"
          isOpen={this.state.isCreatingTestTemplate}
          onClose={() => this.closeTestTemplate()}
        >
          <CustomForm config={createTestTemplateConfig} isLoading={this.state.isLoadingCreate}
                      onSubmit={form => this.saveTestTemplate(form)}/>
        </Modal>

        <Modal
          isOpen={!!this.state.testTemplateForArchive}
          title="Archive test template"
          onClose={() => this.setState({testTemplateForArchive: null})}
        >
          <div className="task-group-activate-modal">
            <h4>Are you sure you want to archive test template named: {this.state.testTemplateForArchive && this.state.testTemplateForArchive.title}?</h4>
            <div>
              <button className="button secondary"  onClick={() => this.setState({testTemplateForArchive: null})}>
                No
              </button>
              <button className="button primary" onClick={() => this.archiveTestTemplate(this.state.testTemplateForArchive)}>
                Yes
              </button>
            </div>
          </div>
        </Modal>
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestTemplates));
